<template>
  <form v-if="course.enrolled" :id="`course_${course.id}`" method="POST" action="/api/sso/saml/" target="_blank" class="professional-development__card card" @click.prevent="submitAccessRequest">
    <input type="hidden" name="portal_user_id" v-model="userId" />
    <input type="hidden" name="email" v-model="userEmail" />
    <input type="hidden" name="name" v-model="userName" />
    <input type="hidden" name="token" v-model="userToken" />
    <div class="card__logo-container">
      <div class="card__logo-wrapper">
        <img class="card__logo" :src="decode(course.imageUrl)" v-if="course.imageUrl">
        <span class="fa fa-adjust card__placeholder" aria-hidden="true" v-else></span>
      </div>
    </div>
    <div class="card__title">{{ course.title }}</div>
    <div class="card__description" v-html="course.description"></div>
    <div class="card__view-btn">Access Course <span class="glyphicon glyphicon-share-alt" aria-hidden="true"></span></div>
  </form>
  <div v-else class="professional-development__card card card--faded" @click.stop="activateModal">
    <div class="card__logo-container">
      <div class="card__logo-wrapper">
        <img class="card__logo" :src="decode(course.imageUrl)" v-if="course.imageUrl">
        <span class="fa fa-adjust card__placeholder" aria-hidden="true" v-else></span>
      </div>
    </div>
    <div class="card__title">{{ course.title }}</div>
    <div class="card__description" v-html="course.description"></div>
    <div class="card__view-btn">Request More Info</div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FuelUtilities from "../utils/FuelUtilities.js";

  export default {
    name: 'CourseCard',
    mixins: [FuelUtilities],
    data() {
      return {
        modalKey: 'courseModal',
      };
    },
    props: {
      course: Object,
    },
    computed: {
      ...mapGetters('auth', ['user']),
      userToken() {
        return this.user.token;
      },
      userEmail() {
        return this.user.userInfo.email;
      },
      userName() {
        return `${this.user.userInfo.first_name} ${this.user.userInfo.last_name}`;
      },
      userId() {
        return this.user.portal_user_id;
      },
    },
    methods: {
      activateModal() {
        this.$store.dispatch('main/showModal', this.modalKey);
        this.$store.dispatch('main/setProperty', { key: 'modalData', value: this.course });
      },
      modalData() {
        return this.course;
      },
      submitAccessRequest() {
        document.getElementById(`course_${this.course.id}`).submit();
      },
    },
  };
</script>

<style scoped>
  .card__view-btn span {
    margin-left: 8px;
  }
</style>
